import $x from '@/utils/$x';

export async function getGreetList(params) {
  return $x.post('/v1/litta/greet/list', params);
}
// 带参列表查询
export async function queryPushInfoList(params) {
  return $x.post('/officialAcocounts/pushManager/queryPushInfoList', params);
}
// 详情查询
export async function queryPushInfo(params) {
  return $x.post('/officialAcocounts/pushManager/queryPushInfo', params);
}
// 删除
export async function deleltePushInfo(params) {
  return $x.post('/officialAcocounts/pushManager/deleltePushInfo', params);
}
// 新建
export async function addPushInfo(params) {
  return $x.post('/officialAcocounts/pushManager/addPushInfo', params);
}
// 编辑
export async function editPushInfo(params) {
  return $x.post('/officialAcocounts/pushManager/editPushInfo', params);
}
